// Web shim: map native-stack API to the JS stack navigator
export * from '@react-navigation/stack';
export { createStackNavigator as createNativeStackNavigator } from '@react-navigation/stack';
